// Normalise a stored URL to a safe, absolute http(s) URL — or return null.
//
// Mentions, citations and scraped news/social items sometimes store a URL with
// no scheme ("www.bbc.co.uk/news") or a relative path ("/foo"). Passing a
// scheme-less or relative value to window.open()/`<a href>` makes the browser
// resolve it against the SPA's OWN origin — so the "source article" link just
// reloads the dashboard. Only ever open a genuine external URL.
//
//   absUrl("https://x.com/p")  -> "https://x.com/p"
//   absUrl("www.bbc.co.uk/n")  -> "https://www.bbc.co.uk/n"   (scheme assumed)
//   absUrl("/subjects/123")    -> null                        (relative — never open)
//   absUrl("")                 -> null
function absUrl(raw) {
    const u = String(raw || '').trim();
    if (!u) return null;
    if (/^https?:\/\//i.test(u)) return u;
    // Scheme-less but domain-like (has a dot in the first path segment) — assume https.
    if (/^[a-z0-9-]+(\.[a-z0-9-]+)+([\/?#]|$)/i.test(u)) return 'https://' + u;
    return null;   // relative or unrecognised — do NOT resolve against our own origin
}

export { absUrl };
